import React, {useState, useEffect, useContext} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import {
  apollo_industory_master_path,
  apollo_product_master_path,
} from "../../atom/Apollo_links";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {Account} from "../../organism/ACCOUNT/AccountModel";
import {Industory, Product} from "../../organism/MASTER/Apollo_MasterModel";
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
import ApolloMasterProductEdit from "../../organism/MASTER/Apollo_MasterProductEdit";
import {
  valueToOption,
} from "../../atom/Apollo_styles";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";

import ApolloMasterIndustoryModal, {PropsModal} from "../../organism/MASTER/Apollo_MasterIndustoryModal";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// エラーメッセージ
const MESSGAE = [
  "業種の更新に成功しました",
];
  
// エラーメッセージ
const ERROR_MESSGAE = [
  "業種の取得に失敗しました",
  "商品の取得に失敗しました",
  "業種の更新に失敗しました",
  "業種名は1文字以上で入力して下さい",
  "業種名は255文字以内で入力して下さい",
];
  
export type PropsCategory = {
  industoryId: number      // 選択値
  productId: number        // 選択値
  setIndustoryId: any      // 選択値セット関数
  setProductId: any        // 選択値セット関数
  setIndustoryName: any    // 選択値セット関数
  setProductName: any      // 選択値セット関数
  account: Account         // アカウント情報
}

interface CategoryProps {
  propsCategory: PropsCategory
};

// カテゴリ選択セレクトボックス表示
export default function ApolloCategory(props: CategoryProps) {

  const {
    industoryId,
    productId,
    setIndustoryId,
    setProductId,
    account,
  } = props.propsCategory;

  const classes = apollo_useStyles();
  
  // オプション+業種定義
  type OptionLocal = {
    value: number;
    label: string;
    industoryId: number;
    industoryName: string;
  }

  const {accountid} = useParams<{accountid: string}>();
  const [read, setRead] = useState(false);
  const [id, setId] = useState(0);
  const {data, setmsg} = useContext(ApolloMessage);
  const [industory, setIndustory] = useState<Industory[]>();
  const [product, setProduct] = useState<Product[]>();
  const [optionProducts, setOptionProducts] = useState<OptionLocal[]>([]);
  const [industoryIdLocal, setIndustoryIdLocal] = useState<number>(industoryId);
  const [industoryName, setIndustoryName] = useState<string>("");
  const [industoryNameOld, setIndustoryNameOld] = useState<string>("");
  const [productIdLocal, setProductIdLocal] = useState<number>(productId);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [errFlag, setErrFlag] = useState<boolean>(false);
  
  const {errors, setError, clearErrors} = useForm();
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  // 業種カテゴリ・業種マスタ・商品マスタ取得
  useEffect(() => {
    // 業種マスタ取得
    const urlIndustory = apollo_industory_master_path;
    ApolloAxios.get(urlIndustory).then(response => {
      if (response.data.resultCode === 0) {
        setIndustory(response.data.result);
        setIndustoryIdLocal(industoryIdLocal);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSGAE[0],
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // 商品マスタ取得
    const urlProduct = apollo_product_master_path;
    ApolloAxios.get(urlProduct).then(response => {
      if (response.data.resultCode === 0) {
        setProduct(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSGAE[1],
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[1], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [read]);

  useEffect(() => {
    // 業種、商品マスタが揃うまでは各種リストは作成しない
    if (!(industory && product)) return;
    // 各種リスト初期設定
    initList();
  }, [industory, product, account]);
  
  // 各種リスト初期設定
  const initList = () => {
    // 商品リストを作成する
    createProductOption();
  }

  var newOptionProducts: OptionLocal[];
  // 商品選択オプション作成
  function createProductOption() {
    newOptionProducts = product ? product.map((product) => {
      var industoryName = "";
      if (industory) {
        for(var i in industory ? industory : []) {
          if (product.industoryId === industory[i].industoryId) {
            industoryName = industory[i].industoryName;
            break;
          }
        }
      }
      return {
        value: product.productId,
        label: product.productName,
        industoryId: product.industoryId,
        industoryName: industoryName,
      }
    }) : [];
    setOptionProducts(newOptionProducts);
    var workId = productId;
    if (id !== 0) {
      // 商品追加
      workId = id
    }
    if (accountid === "0") {
      // 新規作成の場合
      setProductId(newOptionProducts[0].value);
      setProductIdLocal(newOptionProducts[0].value);
      setIndustoryId(newOptionProducts[0].industoryId);
      setIndustoryIdLocal(newOptionProducts[0].industoryId);
      setIndustoryName(newOptionProducts[0].industoryName);
      setIndustoryNameOld(newOptionProducts[0].industoryName);
    } else {
      // 変更の場合
      setProductId(workId);
      setProductIdLocal(workId);
      setIndustoryId(newOptionProducts.find((v) => v.value === workId)?.industoryId ?? 0);
      setIndustoryIdLocal(newOptionProducts.find((v) => v.value === workId)?.industoryId ?? 0);
      setIndustoryName(newOptionProducts.find((v) => v.value === workId)?.industoryName ?? "");
      setIndustoryNameOld(newOptionProducts.find((v) => v.value === workId)?.industoryName ?? "");
    }
  }
  
  // クローズボタンハンドラ
  const handleClickEditClose = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
  }
  
  // 商品追加ボタンハンドラ
  const handleClickEditOpen = () => {
    setProductId(productIdLocal);
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }
  
  // 業種名変更ボタンハンドラ
  const handleEditIndustory = () => {
    if (!industory) return;
    if (industoryName.length === 0) {
      // 空文字はエラーとする
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: ERROR_MESSGAE[3],
        },
      });
      return;
    }
    if (byteLengthOf(industoryName) > 255) {
      // 255文字より多い場合はエラーとする
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: ERROR_MESSGAE[4],
        },
      });
      return;
    }
    // 変更した業種を確定する
    var idx = -1;
    for (var i in industory) {
      // 変更した業種名称を設定する
      if (industory[Number(i)].industoryId === industoryIdLocal) {
        industory[Number(i)].industoryName = industoryName;
        idx = Number(i);
        break;
      }
    }
    if (idx < 0) return;
    // URL
    const url = apollo_industory_master_path + "/" + industoryIdLocal;
    // 業種マスタ更新
    ApolloAxios.put(url, industory[idx]).then(response => {
      if (response.data.resultCode === 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: MESSGAE[0]
          }
        });
        setDisabled(true);
        setIndustoryNameOld(industoryName);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSGAE[2],
          }
        });
      }
    }).catch(err => {
      const errMsg = err.message ? err.message : ERROR_MESSGAE[2];
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[2], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    })
  }

  // 商品変更ハンドラ
  const handleChangeBill = (event: any, element: any, reason: any) => {
    if (reason === "select-option" && element !== null) {
      if (element.value !== null) {
        handleChangeProduct(element.value);
      }
    } else if (reason === "clear") {
      handleChangeProduct(0);
    }
  };
  
  // 商品変更処理
  const handleChangeProduct = (value: any) => {
    setProductIdLocal(value);
    setProductId(value);
    setIndustoryId(optionProducts.find((v) => v.value === value)?.industoryId ?? 0);
    setIndustoryName(optionProducts.find((v) => v.value === value)?.industoryName ?? "");
    setIndustoryNameOld(optionProducts.find((v) => v.value === value)?.industoryName ?? "");
    props.propsCategory.setIndustoryName(optionProducts.find((v) => v.value === value)?.industoryName ?? "");
    props.propsCategory.setProductName(optionProducts.find((v) => v.value === value)?.label ?? "");
  };

  // 文字バイト数算出
  const byteLengthOf = (s:string)  => {
    return (new Blob([s])).size;
  }


  // 業種変更ハンドラ
  const handleChangeIndustory = (event: any) => {

    var industoryNameWork = event.target.value;
    setIndustoryName(industoryNameWork);
    props.propsCategory.setIndustoryName(industoryNameWork);
    clearErrors(["productName","industoryName"]);
    setErrFlag(false);

    if (productIdLocal === 0) {
      setError("productName", {
        type: "manual",
        message: "必須選択項目です。"
      })
      setErrFlag(true);
    }
    if (industoryNameWork.trim() === "") {
      setError("industoryName", {
        type: "manual",
        message: "1文字以上を入力してください。"
      })
      setErrFlag(true);
      setDisabled(true);
    } else {
      if (byteLengthOf(industoryNameWork) > 255) {
        setError("industoryName", {
          type: "manual",
          message: "255文字以内で入力してください。"
        })
        setErrFlag(true);
        setDisabled(true);
      }
    }
  };

  // 業種名変更ボタン制御
  useEffect(() => {
    // 業種名に変更がない場合、ボタンは非活性化する
    if (industoryName === industoryNameOld) {
      setDisabled(true);
    } else {
      if (!errFlag) {
        setDisabled(false);
      }
    }
  }, [industoryName]);

  // 業種ID変更制御
  useEffect(() => {
    props.propsCategory.setIndustoryId(industoryIdLocal);
  }, [industoryIdLocal]);

  // 商品ID変更制御
  useEffect(() => {
    props.propsCategory.setProductId(productIdLocal);
  }, [productIdLocal]);

  // 商品・業種モーダル引数
  var propsModal:PropsModal = {
    setRead : setRead,
    read : read,
    industorycategoryId : 0,
    industoryId : industoryIdLocal,
    setIndustoryId : setIndustoryIdLocal,
    productId : productIdLocal,
    setProductId : setProductIdLocal,
    setIndustoryName : setIndustoryName,
    setIndustoryNameOld : setIndustoryNameOld,
    setProductName : props.propsCategory.setProductName,
    setIndustoryNameLog : props.propsCategory.setIndustoryName,
  };

  // 画面表示
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {/* カテゴリ検索ボタン */}
        <ApolloMasterIndustoryModal propsModal={propsModal} />
      </Grid>
      <Grid item xs={12} md={10}>
        <InputLabel id="productName">
          <Typography variant="caption">
          商品名称 *
          </Typography>
        </InputLabel>
        <FormControl error={errors.productName ? true : false} fullWidth>
          <Autocomplete
            id="productName"
            value={valueToOption(productIdLocal, optionProducts)}
            key={optionProducts.length ? "Loaded" : "Loading"}
            options={optionProducts}
            onChange={(event, element, reason) => handleChangeBill(event, element, reason)}
            size="small"
            closeIcon=""
            getOptionSelected={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => <TextField {...params} variant="outlined"/>}
            />
        <FormHelperText>{errors.status && errors.status.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2}>
        <Button className={classes.buttonTop} variant="contained" color="primary" onClick={handleClickEditOpen}>
        商品追加
        </Button>
      </Grid>

      <Grid item xs={12} md={10}>
        <TextField
          id="industoryName"
          name="industoryName"
          label="業種"
          fullWidth
          key={`industoryName_key` ? "Loaded" : "Loading"}
          value={industoryName}
          disabled={true}
          required={true}
          onChange={(e) => handleChangeIndustory(e)}
          helperText={errors.industoryName && errors.industoryName.message}
          error={errors.industoryName ? true : false}
        />
      </Grid>
      {/* <Grid item xs={12} md={2}>
        <ApolloButton handleButton={handleEditIndustory} title="業種名変更" text={`この業種を変更しますか？`} disabled={disabled}/>
      </Grid> */}
      {/* ドロワー表示 */}
      <RightDrawer>
        <ApolloMasterProductEdit productId={0} read={read} setRead={setRead} close={handleClickEditClose} setId={setId} setName={props.propsCategory.setProductName} setIndustoryName={props.propsCategory.setIndustoryName}/>
      </RightDrawer>
    </Grid>
  )
}
